import { Stack, Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { getString } from '../../../helper/util'
import DeviceVersionList from './DeviceVersionList'

const DEVICE_TYPES = ['PR', 'KIOSK', 'TV']

export default function VersionConfigListForm({
    versionConfigList = [],
    //   resource,
    lang,
    theme,
    deleteMode = false,
    inputError = {},
    helperTextStylesClasses,
    onChangeVersionConfigList,
    handleFolderMap,
    handleOnClickDrawer,
    disabled = false,
    }) {
    const addedDeviceTypes = versionConfigList.map((i) => i.deviceType)
    const resource = 'appVersionRestaurantPage'

    return (
        <Stack spacing={2}>
        {/* ── Add device type buttons ── */}
        {!disabled && (
            <Stack direction="row" spacing={1}>
            {DEVICE_TYPES.map((type) => (
                <Button
                key={type}
                variant="contained"
                //   size="small"
                startIcon={<AddIcon />}
                disabled={addedDeviceTypes.includes(type)}
                onClick={() => handleFolderMap(type)}
                >
                {getString(lang, resource, type.toLowerCase(), theme)}
                </Button>
            ))}
            </Stack>
        )}

        {/* ── Device version list ── */}
        {versionConfigList.length > 0 && (
            <DeviceVersionList
            rawData={versionConfigList}
            resource={resource}
            lang={lang}
            theme={theme}
            deleteMode={deleteMode}
            inputError={inputError}
            helperTextStylesClasses={helperTextStylesClasses}
            onChangeVersionConfigList={onChangeVersionConfigList}
            handleFolderMap={handleFolderMap}
            handleOnClickDrawer={handleOnClickDrawer}
            disabled={disabled}
            />
        )}
        </Stack>
    )
}